import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortingOrderType } from 'src/app/interfaces/search.interface';
import { SortIconItemOptions } from './sort-icon-item.helpers';

@Component({
  selector: 'app-sort-icon-item',
  templateUrl: './sort-icon-item.component.html',
  styleUrls: ['./sort-icon-item.component.scss'],
})
export class SortIconItemComponent {
  @Input({ required: true }) public title: string;
  @Input({ required: true }) public isLoading: boolean;
  @Input({ required: true }) sortParams: SortIconItemOptions;

  @Output() public toggleSorting: EventEmitter<SortingOrderType> = new EventEmitter<SortingOrderType>();

  public readonly ASCENDING_ICON = 'assets/icons/icon-ascending-arrow.svg';
  public readonly DESCENDING_ICON = 'assets/icons/icon-descending-arrow.svg';

  public toggleSortingOrder(): void {
    this.toggleSorting.emit(this.sortParams.preparedSortCategory);
  }
}
